(function () {
  function initCheckoutGuard(wrapId, vknSelector, btnId, teslimatSelector) {
    var wrap = document.getElementById(wrapId);
    var btn  = document.getElementById(btnId);
    if (!wrap || !btn) return;

    var cbs = Array.from(wrap.querySelectorAll('.adell-consent__cb'));
    var vkn = vknSelector ? document.querySelector(vknSelector) : null;
    var teslimat = teslimatSelector ? document.querySelector(teslimatSelector) : null;

    function consentOk() {
      return cbs.every(function (cb) { return cb.checked; });
    }

    // Fatura kartinin kurallari kartin kendisinde (cart.js CartVkn.dogrula).
    // ayri secilmis olmasi orada ele alinir.
    function faturaHatasi() {
      if (!vkn || typeof vkn.dogrula !== 'function') return '';
      return vkn.dogrula();
    }

    function vknOk() {
      return !faturaHatasi();
    }

    function teslimatHatasi() {
      if (!teslimat || typeof teslimat.dogrula !== 'function') return '';
      return teslimat.dogrula();
    }

    function updateBtn() {
      if (consentOk() && vknOk() && !teslimatHatasi()) {
        btn.classList.remove('adell-checkout-locked');
        btn.removeAttribute('aria-disabled');
      } else {
        btn.classList.add('adell-checkout-locked');
        btn.setAttribute('aria-disabled', 'true');
      }
    }

    updateBtn();
    cbs.forEach(function (cb) { cb.addEventListener('change', updateBtn); });
    if (vkn) {
      vkn.addEventListener('input', updateBtn);
      vkn.addEventListener('click', updateBtn);
    }
    if (teslimat) {
      teslimat.addEventListener('input', updateBtn);
      teslimat.addEventListener('change', updateBtn);
    }

    btn.addEventListener('click', function (e) {
      if (!consentOk()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        wrap.classList.add('adell-consent--shake');
        setTimeout(function () { wrap.classList.remove('adell-consent--shake'); }, 600);
        return;
      }
      if (!vknOk()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        vkn.classList.add('adell-consent--shake');
        setTimeout(function () { vkn.classList.remove('adell-consent--shake'); }, 600);
        vkn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var teslimatMesaji = teslimatHatasi();
      if (teslimatMesaji) {
        e.preventDefault();
        e.stopImmediatePropagation();
        teslimat.hataGoster(teslimatMesaji);
        teslimat.classList.add('adell-consent--shake');
        setTimeout(function () { teslimat.classList.remove('adell-consent--shake'); }, 600);
        teslimat.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!teslimat || typeof teslimat.odemeAdresi !== 'function' || btn.dataset.adresAktarildi === '1') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.dataset.adresAktariliyor === '1') return;
      btn.dataset.adresAktariliyor = '1';
      odemeyeAdresiAktar(teslimat, vkn).then(function () {
        btn.dataset.adresAktariliyor = '';
        btn.dataset.adresAktarildi = '1';
        btn.click();
        btn.dataset.adresAktarildi = '';
      });
    }, true);
  }

  var ADRES_SORGUSU = 'mutation AdresYaz($id: ID!, $addresses: [CartSelectableAddressInput!]!) { cartDeliveryAddressesReplace(cartId: $id, addresses: $addresses) { userErrors { message } } }';

  function odemeyeAdresiAktar(teslimat, vkn) {
    var is = Promise.resolve(teslimat.yaz()).then(function () {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }).then(function (sepet) {
      if (!sepet || !sepet.token) return;
      var adres = Object.assign({}, teslimat.odemeAdresi(),
        vkn && typeof vkn.odemeAdi === 'function' ? vkn.odemeAdi() : {});
      Object.keys(adres).forEach(function (k) { if (!adres[k]) delete adres[k]; });
      return fetch('/api/2026-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: ADRES_SORGUSU,
          variables: {
            id: 'gid://shopify/Cart/' + sepet.token,
            addresses: [{ selected: true, oneTimeUse: true, address: { deliveryAddress: adres } }]
          }
        })
      });
    }).catch(function () {});
    var zamanAsimi = new Promise(function (coz) { setTimeout(coz, 4000); });
    return Promise.race([is, zamanAsimi]);
  }

  function boot() {
    initCheckoutGuard('adell-consent-main',   '#AdellVknMain',   'adell-checkout-main',   '#AdellTeslimatMain');
    initCheckoutGuard('adell-consent-drawer', '#AdellVknDrawer', 'adell-checkout-drawer', '#AdellTeslimatDrawer');
    initB2bIyzicoCheckout();
  }

  function initB2bIyzicoCheckout() {
    var button = document.getElementById('adell-checkout-main');
    var planPanel = document.querySelector('.adell-plan-legacy.apl');
    if (!button || !planPanel || button.dataset.iyzicoBound === 'true') return;

    button.dataset.iyzicoBound = 'true';
    // Taksit alt siniri: sinirin altindaki sepetlerde vadeli planlar kapatilir.
    // Olcu TEK CEKIM tutari (cash butonunun data-total-raw degeri, kurus cinsinden)
    function taksitLimitiUygula(altSinirTl) {
      var sinir = Number(altSinirTl);
      if (!isFinite(sinir) || sinir <= 0) return;
      var nakit = planPanel.querySelector('[data-adell-plan="cash"]');
      if (!nakit) return;
      var toplamTl = (parseFloat(nakit.dataset.totalRaw) || 0) / 100;
      var yeterli = toplamTl >= sinir;
      var bicim = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });
      planPanel.querySelectorAll('[data-adell-plan]').forEach(function (btn) {
        if (btn.dataset.adellPlan === 'cash') return;
        btn.disabled = !yeterli;
        btn.style.opacity = yeterli ? '' : '.45';
        btn.style.cursor = yeterli ? '' : 'not-allowed';
        btn.title = yeterli ? '' : bicim.format(sinir) + ' TL ve uzeri siparislerde acilir';
      });
      var not = planPanel.querySelector('[data-taksit-limit-not]');
      if (!yeterli) {
        var secili = planPanel.querySelector('[data-adell-plan].is-on');
        if (secili && secili.dataset.adellPlan !== 'cash') nakit.click();
        if (!not) {
          not = document.createElement('p');
          not.setAttribute('data-taksit-limit-not', '');
          not.style.cssText = 'margin:12px 0 0;font-size:11.5px;color:#8a6d3b;background:#fdf6e3;'
            + 'border-radius:8px;padding:10px 12px;line-height:1.45';
          planPanel.appendChild(not);
        }
        not.textContent = 'Taksitli odeme ' + bicim.format(sinir)
          + ' TL ve uzeri siparislerde gecerlidir. Sepet tutariniz '
          + bicim.format(toplamTl) + ' TL.';
      } else if (not) {
        not.remove();
      }
    }

    var secimAlanlari = ['il', 'ilce'];
    var alanSirasi = ['firstName','lastName','company','taxNumber','vergiDairesi','il','ilce','mahalle','sokak','bina','daire','zip','phone'];
    var labels = {
      firstName: 'Ad', lastName: 'Soyad', company: 'Şirket', taxNumber: 'Vergi No',
      vergiDairesi: 'Vergi Dairesi',
      il: 'İl', ilce: 'İlçe', mahalle: 'Mahalle', sokak: 'Cadde / Sokak',
      bina: 'Bina no', daire: 'Daire no', zip: 'Posta kodu', phone: 'Telefon'
    };
    var yerTutucu = { mahalle: 'örn. Atatürk Mahallesi', sokak: 'örn. Hürriyet Bulvarı', bina: '54', daire: 'örn. 3 veya yok' };
    var genisAlanlar = ['company', 'mahalle', 'sokak'];
    var zorunluAlanlar = ['firstName','lastName','company','taxNumber','vergiDairesi','il','ilce','mahalle','sokak','bina','daire','zip','phone'];

    var card = document.createElement('div');
    card.className = 'adell-b2b-address';
    card.style.cssText = 'margin:16px 20px;padding:18px;border:0;border-radius:0;background:#fff;font:inherit';
    card.style.padding = '0 18px 18px';
    card.innerHTML = '<div style="background:#111;color:#fff;margin:0 -18px 16px;padding:12px 18px;text-align:center;font-size:11px;letter-spacing:.08em;font-weight:700">TESLİMAT VE FATURA BİLGİLERİ</div><div data-fields style="display:grid;grid-template-columns:1fr 1fr;gap:10px"></div><label style="display:block;margin-top:12px;font-size:12px"><input type="checkbox" checked data-efatura> E-fatura mükellefiyim</label><label style="display:block;margin-top:8px;font-size:12px"><input type="checkbox" checked data-same> Fatura adresi teslimat adresiyle aynı</label><p data-error style="margin:10px 0 0;color:#b42318;font-size:12px"></p>';
    planPanel.insertAdjacentElement('afterend', card);
    var holder = card.querySelector('[data-fields]');

    var GIRDI_STILI = 'padding:10px;border:1px solid #d9d8d2;border-radius:6px;font:inherit;background:#fff';
    alanSirasi.forEach(function (key) {
      var wrap = document.createElement('label');
      wrap.style.cssText = (genisAlanlar.indexOf(key) >= 0 ? 'grid-column:1/-1;' : '')
        + 'font-size:11px;color:#555;display:grid;gap:4px';
      var zorunlu = zorunluAlanlar.indexOf(key) >= 0 ? ' required' : '';
      if (secimAlanlari.indexOf(key) >= 0) {
        wrap.innerHTML = labels[key] + '<select data-field="' + key + '" style="' + GIRDI_STILI + '"'
          + zorunlu + (key === 'ilce' ? ' disabled' : '') + '><option value="">'
          + (key === 'ilce' ? 'Önce il seçiniz' : 'Seçiniz') + '</option></select>';
      } else {
        wrap.innerHTML = labels[key] + '<input data-field="' + key + '" style="' + GIRDI_STILI + '"'
          + (yerTutucu[key] ? ' placeholder="' + yerTutucu[key] + '"' : '')
          + (key === 'zip' ? ' inputmode="numeric" maxlength="5"' : '')
          + (key === 'phone' ? ' inputmode="tel"' : '') + zorunlu + '>';
      }
      holder.appendChild(wrap);
    });

    var alan = function (key) { return card.querySelector('[data-field="' + key + '"]'); };
    var deger = function (key) { var el = alan(key); return el ? (el.value || '').trim() : ''; };

    function ilListesiniDoldur() {
      if (!window.ADELL_TR) return;
      var parcalar = ['<option value="">Seçiniz</option>'];
      window.ADELL_TR.ilListesi().forEach(function (ad) {
        parcalar.push('<option value="' + ad + '">' + ad + '</option>');
      });
      alan('il').innerHTML = parcalar.join('');
    }

    function ilceListesiniDoldur(ilAdi, secili) {
      if (!window.ADELL_TR) return;
      var ilceAlani = alan('ilce');
      var ilceler = window.ADELL_TR.ilceler(ilAdi);
      if (!ilceler.length) {
        ilceAlani.innerHTML = '<option value="">Önce il seçiniz</option>';
        ilceAlani.disabled = true;
        return;
      }
      var parcalar = ['<option value="">Seçiniz</option>'];
      ilceler.forEach(function (ad) {
        parcalar.push('<option value="' + ad + '"' + (ad === secili ? ' selected' : '') + '>' + ad + '</option>');
      });
      ilceAlani.innerHTML = parcalar.join('');
      ilceAlani.disabled = false;
    }

    alan('il').addEventListener('change', function () { ilceListesiniDoldur(deger('il'), ''); });

    function onDoldur(baglam, sepetNitelikleri) {
      var a = (baglam && baglam.shippingAddress) || {};
      var n = sepetNitelikleri || {};
      var koy = function (key, value) { var el = alan(key); if (el && value) el.value = value; };

      koy('firstName', a.firstName);
      koy('lastName', a.lastName);
      koy('company', a.company || (baglam && baglam.company) || '');
      koy('taxNumber', a.taxNumber || (baglam && baglam.taxNumber) || '');
      koy('vergiDairesi', n.vergi_dairesi || '');
      koy('zip', n.teslimat_posta_kodu || a.zip || '');
      koy('phone', n.teslimat_telefon || a.phone || '');
      koy('mahalle', n.teslimat_mahalle || '');
      koy('sokak', n.teslimat_sokak || a.address1 || '');
      koy('bina', n.teslimat_bina_no || '');
      koy('daire', n.teslimat_daire_no || '');

      if (!window.ADELL_TR) return;
      ilListesiniDoldur();
      var il = window.ADELL_TR.ilEslestir(n.teslimat_il || '')
        || window.ADELL_TR.ilEslestir(a.city || '')
        || window.ADELL_TR.postaKodundanIl(deger('zip'));
      var ilce = '';
      if (!il) {
        // Sehir alanina ilce yazilmis olabilir ("Basaksehir" gibi).
        var bulunan = window.ADELL_TR.ilceyeGoreIlBul(a.city || '');
        if (bulunan) { il = bulunan.il; ilce = bulunan.ilce; }
      }
      if (il) {
        alan('il').value = il;
        ilce = window.ADELL_TR.ilceEslestir(il, n.teslimat_ilce || '')
          || ilce
          || window.ADELL_TR.ilceEslestir(il, a.city || '');
        ilceListesiniDoldur(il, ilce);
        if (ilce) alan('ilce').value = ilce;
      }
    }

    function ilVerisiHazir(sonra) {
      if (window.ADELL_TR) { sonra(); return; }
      window.addEventListener('load', sonra, { once: true });
    }

    Promise.all([
      fetch('/apps/b2b-checkout/review-context', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); }),
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { return {}; })
    ]).then(function (sonuclar) {
      var baglam = sonuclar[0];
      var nitelikler = (sonuclar[1] && sonuclar[1].attributes) || {};
      ilVerisiHazir(function () { onDoldur(baglam, nitelikler); });
      taksitLimitiUygula(baglam.taksitAltSiniri);
    }).catch(function () {
      card.querySelector('[data-error]').textContent = 'Şirket adresi yüklenemedi. Lütfen bilgileri girin.';
      ilVerisiHazir(function () { onDoldur(null, {}); });
    });

    function tekSatirAdres() {
      var parcalar = [deger('mahalle'), deger('sokak')];
      var bina = deger('bina');
      var daire = deger('daire');
      if (bina) parcalar.push('No: ' + bina);
      if (daire && !/^(yok|-|0)$/i.test(daire)) parcalar.push('Daire: ' + daire);
      return parcalar.filter(Boolean).join(' ');
    }

    button.addEventListener('click', function (event) {
      var selectedPlan = planPanel.querySelector('[data-adell-plan].is-on');
      if (!selectedPlan) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      var uyar = function (m) {
        event.preventDefault();
        card.querySelector('[data-error]').textContent = m;
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      // teslimat niteliginde tam adiyla duruyor.
      var address = {
        country: 'Turkey',
        firstName: deger('firstName'),
        lastName: deger('lastName'),
        company: deger('company'),
        taxNumber: deger('taxNumber'),
        address1: tekSatirAdres(),
        address2: '',
        city: deger('ilce'),
        zip: deger('zip'),
        phone: deger('phone')
      };

      var eksik = zorunluAlanlar.filter(function (k) { return !deger(k); });
      if (eksik.length) {
        uyar('Teslimat ve fatura bilgilerinde eksik alan var: '
          + eksik.map(function (k) { return labels[k]; }).join(', ') + '.');
        return;
      }

      var vkn = (address.taxNumber || '').replace(/\D/g, '');
      if (vkn.length !== 10 && vkn.length !== 11) {
        uyar('Vergi No 10 haneli olmalıdır (şahıs firmalarında 11 haneli TC kimlik no).');
        return;
      }
      address.taxNumber = vkn;

      var pk = (address.zip || '').replace(/\D/g, '');
      if (pk.length !== 5) {
        uyar('Posta kodu 5 haneli olmalıdır (kargo şehri buradan belirleniyor).');
        return;
      }
      address.zip = pk;

      var efatura = card.querySelector('[data-efatura]');
      var fatura = {
        vergi_dairesi: deger('vergiDairesi'),
        efatura_mukellef: (efatura && efatura.checked) ? 'evet' : ''
      };

      var teslimat = {
        il: deger('il'),
        ilce: deger('ilce'),
        mahalle: deger('mahalle'),
        sokak: deger('sokak'),
        bina: deger('bina'),
        daire: deger('daire'),
        adres: address.address1,
        posta_kodu: pk,
        telefon: address.phone
      };

      event.preventDefault();
      event.stopImmediatePropagation();

      var nitelikYaz = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          teslimat_il: teslimat.il,
          teslimat_ilce: teslimat.ilce,
          teslimat_mahalle: teslimat.mahalle,
          teslimat_sokak: teslimat.sokak,
          teslimat_bina_no: teslimat.bina,
          teslimat_daire_no: teslimat.daire,
          teslimat_adres: teslimat.adres,
          teslimat_posta_kodu: teslimat.posta_kodu,
          teslimat_telefon: teslimat.telefon,
          vergi_dairesi: fatura.vergi_dairesi,
          efatura_mukellef: fatura.efatura_mukellef
        } })
      }).catch(function () {});

      nitelikYaz.then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        var lines = cart.items.map(function (i) { return { variantId: i.variant_id, quantity: i.quantity }; });
        var secili = planPanel.querySelector('[data-adell-plan].is-on') || {};
        var hamTutar = parseFloat((secili.dataset || {}).totalRaw);
        var govde = {
          plan: (secili.dataset || {}).adellPlan,
          shippingAddress: address,
          billingAddress: address,
          lines: lines,
          taxNumber: address.taxNumber,
          teslimat: teslimat,
          fatura: fatura
        };
        // Sepetin gosterdigi toplam sunucuya bilgi olarak da gider; sunucu kendi
        // hesabiyla ayrisirsa odemeyi baslatmaz. Deger kurus cinsinden tutulur.
        if (isFinite(hamTutar)) govde.expectedTotal = hamTutar / 100;
        var form = document.createElement('form');
        form.method = 'POST';
        form.action = 'https://www.adell.com/apps/b2b-checkout/create-iyzico-payment';
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'payload';
        input.value = JSON.stringify(govde);
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
      }).catch(function(){card.querySelector('[data-error]').textContent='Ödeme başlatılamadı. Tekrar deneyin.'});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // FoxTheme cart drawer re-render events
  document.addEventListener('cart:open',    boot);
  document.addEventListener('cart:updated', boot);
})();
